import React from 'react'
import styled, { useTheme } from 'styled-components'
import { FlexRow, IconContainer, Image, Logo, Text } from 'styles/generics'
import moveoGroupIconSvg from 'assets/images/moveo.svg'
import { Link } from 'react-router-dom'
import { footerLinks } from 'constants/footer-links'
import { socialIcons } from 'constants/social-media-links'
import { ThemeInterface } from 'styles/theme'

export const Footer: React.FC = () => {
  const theme = useTheme() as ThemeInterface

  return (
    <FooterContainer>
      <Text fontSize="24px" weight={700} color={theme.colors.white}>
        השותפים שלנו
      </Text>
      <HJBCLogoContainer>
        <Logo />
      </HJBCLogoContainer>
      <LinksRow justify="center" gap={30} width="100%">
        {footerLinks.map((link) => (
          <FooterLink key={link.text} to={link.to}>
            {link.text}
          </FooterLink>
        ))}
      </LinksRow>
      <FlexRow gap={22}>
        {socialIcons.map((icon) => (
          <IconContainer key={icon.alt} width="24px">
            <Image src={icon.src} alt={icon.alt} />
          </IconContainer>
        ))}
      </FlexRow>
      <MoveoCreditRow align="center" gap={5}>
        <MoveoGroupIconContainer align="center">
          <Image src={moveoGroupIconSvg} alt="moveo group icon" />
        </MoveoGroupIconContainer>
        <Text fontSize="12px" weight={500} color={theme.colors.white}>
          Created by Moveo Group
        </Text>
      </MoveoCreditRow>
    </FooterContainer>
  )
}

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  background-color: ${({ theme }) => theme.hjRed};
  padding: 30px 50px;
  direction: rtl;
`

const HJBCLogoContainer = styled.div`
  width: 100px;
`

const LinksRow = styled(FlexRow)`
  flex-wrap: wrap;

  ${({ theme }) => theme.media.xs`
      gap: 50px;

      & > a:not(:first-child) {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          right: -25px;
          top: 50%;
          transform: translateY(-50%);
          height: 100%;
          width: 1px;
          background-color: #fff;
        }
  `}
`

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.white};
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
`

const MoveoGroupIconContainer = styled(FlexRow)`
  width: 31px;
`

const MoveoCreditRow = styled(FlexRow)`
  direction: ltr;
`
